import React, { useState } from "react";
import { Button, Input } from "antd";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../common/Navbar";
import { handleForgotPasswordSubmit } from "../../services/LoginService";
import { BASE_IMG, BRAND_NAME, BRAND_TAGLINE, LOGIN_LOGO_IMG, LOGIN_TITLE_IMG } from "../../constants";
import { showErrorMessage, showLoader, showSuccessMessage } from "../../utils";
import "./style.css";

export default function ForgotPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email) {
      showErrorMessage("Enter your email");
      return;
    }
    setIsLoading(true);
    const { success, message = "" } = await handleForgotPasswordSubmit(email);
    if (success) {
      setIsSubmitted(true);
      showSuccessMessage(message || "Password reset instructions sent");
      navigate("/login");
    } else {
      showErrorMessage(message || "Could not send reset instructions");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>{BRAND_NAME} - Forgot Password</title>
        <meta
          name="description"
          content={`Reset your ${BRAND_NAME} password securely to regain account access.`}
        />
        <link rel="canonical" href="/forgot-password" />
      </Helmet>

      <div>
        <div className="login">
          <div className="left-container">
            <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" alt="Illustration" />
          </div>
          <div className="right-container">
            <div className="right-subContainer">
              <div className="app-title-logo">
                <div className="app-logo">
                  <img src={LOGIN_LOGO_IMG} alt="Logo" height="100%" width="100%" />
                </div>
                {LOGIN_TITLE_IMG ? (
                  <div className="app-title">
                    <img src={LOGIN_TITLE_IMG} alt="Title" />
                  </div>
                ) : null}
              </div>
              <div className="app-motto-text">{BRAND_TAGLINE}</div>

              <div className="register-box-container">
                <div className="login-box-text">Reset password</div>
                {!isSubmitted ? (
                  <form className="auth-form" onSubmit={handleSubmit}>
                    <p className="login-bottom-text-container-middle">
                      Enter your account email. We will send reset instructions.
                    </p>
                    <div className="login-box-input-container">
                      <Input
                        className="login-box-input-container2"
                        type="email"
                        autoComplete="email"
                        value={email}
                        placeholder="Email"
                        onChange={(event) => setEmail(event.target.value)}
                      />
                    </div>
                    <div className="login-box-button-container">
                      <Button
                        className="login-box-button-container-button"
                        htmlType="submit"
                        disabled={!email}
                      >
                        <div className="login-box-button-container-button-text">Continue</div>
                      </Button>
                    </div>
                  </form>
                ) : (
                  <div className="login-bottom-text-container">
                    <p className="login-bottom-text-container-middle">
                      If an account exists for {email}, reset instructions have been sent.
                    </p>
                  </div>
                )}

                <p className="login-bottom-text-container-middle"><Link to="/login">Back to login</Link></p>
              </div>
              <p className="login-bottom-text-container-bottom">
                &copy; Copyright 2026 RazeHQ. All rights reserved.
              </p>
            </div>
          </div>
        </div>
        <Navbar showSettings={false} />
        {isLoading && showLoader("Sending")}
      </div>
    </>
  );
}
